import appLogger from '../logging/appLogger';

/**
 * Specific mark values to be used.
 * Be verbose when adding to this list.
 */
export const PerformanceMarkName = {
    LoginStart: 'login-start',
    LoginComplete: 'login-complete',
    RemoteLoading: 'remote-loading',
    RemoteRender: 'remote-render',
    SearchFacetsLoading: 'search-facets-loading',
    SearchFacetsRender: 'search-facets-render',
    SearchResultsLoading: 'search-results-loading',
    SearchResultsLoaderRender: 'search-results-loader-render',
    SearchResultsRender: 'search-results-render',
    VdpHeaderRender: 'vdp-header-render',
    VdpGalleryRender: 'vdp-gallery-render',
    VdpModalOpen: 'vdp-modal-open',
    VdpModalClose: 'vdp-modal-close',
};

const performanceType = 'performance';

/**
 * Creates performance mark to be used with {@link measure}.
 * @param markName Name of Mark to be used, Reference {@link PerformanceMarkName} for names
 */
export const createMark = (markName: string) => {
    performance.mark(markName);
};

/**
 * Removes performance mark to keep browser performance clean.
 * @param markName Name of mark to be removed.
 */
export const clearMark = (markName: string) => {
    if (!markName) {
        // clearMarks() without a parameter will clear all marks.
        return;
    }
    performance.clearMarks(markName);
};

/**
 * Logs performance measurement between performance marks.
 *   if the two marks are been created.
 * @param startMark Beginning mark for measurement. Reference: {@link PerformanceMarkName}
 * @param endMark End mark for measurement. Reference: {@link PerformanceMarkName}
 * @param additionalProperties Additonal values to be provide on log
 */
export const measure = (
    startMark: string,
    endMark: string,
    additionalProperties?: Record<string, unknown>
) => {
    try {
        const measure = performance.measure(`${startMark}-${endMark}-measure`, startMark, endMark);

        const performanceLog = {
            message: measure.name,
            properties: {
                duration: measure.duration,
                end: endMark,
                measure: measure,
                start: startMark,
                type: performanceType,
                ...additionalProperties,
            },
        };

        appLogger.logTrace(performanceLog);

        performance.clearMeasures(measure.name);
    } catch {
        // measure(...) will throw an error if one of the marks doesn't exist.
    }
};
